import moment from 'moment';

const initState = {
  currentMonth: moment.months().indexOf(moment().format('MMMM')), 
  currentYear: moment().format('Y'), 
  dateObject: moment()
}


const calendarReducer = (state = initState, action) => {
  switch (action.type) {
    case 'CHANGE_DATE_OBJECT_ADD':
      return {
        ...state, 
        dateObject: moment(state.dateObject).add(1, "month"),  
        currentMonth: action.month, 
      }
    case 'CHANGE_DATE_OBJECT_SUBTRACT':
      return {
        ...state, 
        dateObject: moment(state.dateObject).subtract(1, "month"),  
        currentMonth: action.month, 
      }
    default: 
      return state;
  }
}

export default calendarReducer